import React from 'react';
import pinkPlayIcon from '../../../../../assests/realisticIsrael/pinkPlayIcon.png';
import moodleIcon from '../../../../../assests/providers/moodle.png';
import NavigateLink from '../../../features/navigateLink/navigateLink';
import classes from './RealisticIsraelCourses.module.css';

const RealisticIsraelCourses = ({ buttonLink, buttonText, showIcon = false }) => {

    return (
        <NavigateLink link={buttonLink}>
            <div className={classes.Btn}>
                <img src={pinkPlayIcon} alt="" className={classes.PlayIcon} />
                <p>{buttonText}</p>
                {showIcon && (
                    <img src={moodleIcon} alt="" className={classes.MoodleIcon} />
                )}
            </div>
        </NavigateLink>
    );
}
export default RealisticIsraelCourses;